import Auth from '../api/auth';
import Cookies from 'js-cookie';
import { setAuthCredentials } from 'dashboard/store/utils/api';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Inject auth headers from cookie before every request (keeps in sync)
  wootApi.interceptors.request.use(config => {
    try {
      const raw = Cookies.get('cw_d_session_info');
      const data = raw ? JSON.parse(raw) : Auth.getAuthData() || {};
      if (data) {
        const headers = {
          'access-token': data['access-token'],
          'token-type': data['token-type'],
          client: data.client,
          expiry: data.expiry,
          uid: data.uid,
        };
        Object.assign(config.headers, headers);
      }
    } catch (e) {
      // noop
    }
    return config;
  });
  // Response parsing interceptor
  wootApi.interceptors.response.use(response => {
    // Persist refreshed tokens if present
    const at = response.headers?.['access-token'];
    const client = response.headers?.client;
    const uid = response.headers?.uid;
    if (at && client && uid) {
      setAuthCredentials(response);
    }
    return response;
  }, error => parseErrorCode(error));
  return wootApi;
};
